import { Colors } from "../../styles/colors";

export const HandlerColors = (index:number)=> {
		const selectedColor = index <= 3
		? Colors?.tertiary_green_1_dark
		: index > 3 && index < 8 
			? Colors.tertiary_orange_1_light
			: index > 7 && Colors?.tertirary_red_1_dark
		return selectedColor.toString()
}; 